import { combineReducers } from 'redux';
import { reducer as user } from './common/user/userReducer';
import { reducer as form } from 'redux-form';
import { reducer as grid } from '../../hoc/grid';
import { reducer as enterprise } from './enterprise/enterpriseReducer';
import { reducer as safetyLetter } from './safetyLetter/safetyLetterReducer';
import { reducer as bulkdownload } from './common/bulkdownload/bulkDownloadReducer';
import { reducer as message } from './common/messages/messagesReducer';
import { reducer as app } from './common/app/reducer';
import { reducer as config } from './configuration/configurationReducer';
import { reducer as gapPacket } from './gapPacket/gapPacketReducer'

import resetStateReducer from './resetStateReducer';

const rootReducer = combineReducers({
    user,
    form,
    grid,
    app,
    message,
    enterprise,
    safetyLetter,
    config,
    bulkdownload,
    gapPacket
});

export default resetStateReducer(rootReducer);
